var _title, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAgencyApp = function SvgAgencyApp(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "73.000000pt",
    height: "76.000000pt",
    viewBox: "0 0 73.000000 76.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "agency-app")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,76.000000) scale(0.100000,-0.100000)",
    fill: "#3b77d9",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 380 l0 -380 365 0 365 0 0 380 0 380 -365 0 -365 0 0 -380z m420 175 l50 -25 0 -60 0 -60 50 -25 51 -26 -3 -67 -3 -67 -52 -28 -52 -28 -51 26 -50 25 -50 -25 -51 -26 -52 28 -52 28 -3 67 -3 67 51 26 50 25 0 60 0 60 48 24 c59 31 62 31 122 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 541 l-35 -19 38 -18 c35 -17 39 -17 74 0 l38 18 -35 19 c-19 10 -37 18 -40 18 -3 0 -21 -8 -40 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 455 c0 -42 2 -46 40 -65 l40 -20 0 48 c0 45 -2 49 -35 65 -20 9 -38 17 -40 17 -3 0 -5 -20 -5 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 483 c-30 -15 -33 -20 -33 -65 l0 -48 40 20 c38 19 40 23 40 65 0 50 -1 51 -47 28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 371 l-35 -19 38 -18 c35 -17 39 -17 74 0 l38 18 -35 19 c-19 10 -37 18 -40 18 -3 0 -21 -8 -40 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 371 l-35 -19 38 -18 c35 -17 39 -17 74 0 l38 18 -35 19 c-19 10 -37 18 -40 18 -3 0 -21 -8 -40 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 285 c0 -42 2 -46 40 -65 l40 -20 0 48 c0 45 -2 49 -35 65 -20 9 -38 17 -40 17 -3 0 -5 -20 -5 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 313 c-30 -15 -33 -20 -33 -65 l0 -48 40 20 c38 19 40 23 40 65 0 50 -1 51 -47 28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 285 c0 -42 2 -46 40 -65 l40 -20 0 48 c0 45 -2 49 -35 65 -20 9 -38 17 -40 17 -3 0 -5 -20 -5 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503 313 c-30 -15 -33 -20 -33 -65 l0 -48 40 20 c38 19 40 23 40 65 0 50 -1 51 -47 28z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAgencyApp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/agency-app.1dbe0ce4.svg";
export { ForwardRef as ReactComponent };